import React from "react";

const Footer: React.FC = () => {

  const date = new Date();
  const year = date.getFullYear();

  return (
    <footer>
      <div className="row">
        <div className="columns large-12">
          <div className="kew-logo">
            <img src="/assets/default/images/kew-footer-logo.svg" alt="Kew Royal Botanical Gardens"/>
          </div>
          <div className="divider"></div>
          <p className="desktop">© Copyright Board of Trustees of the Royal Botanic Gardens, Kew, {year}<span>|</span> <a href="http://www.kew.org/about-our-organisation/our-policies/privacy-policy">Privacy policy</a> <span>|</span> <a href="http://www.kew.org/Terms-and-Conditions">Terms & conditions</a></p>
          <div className="mobile">
            <p><a href="http://www.kew.org/about-our-organisation/our-policies/privacy-policy">Privacy policy</a></p>
            <p><a href="http://www.kew.org/Terms-and-Conditions">Terms & conditions</a></p>
            <p>© Copyright Board of Trustees of the Royal Botanic Gardens, Kew, {year}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
